import { getCompoundCookie, deleteCookie, getCookieName, getCookieDuration } from './util';
import {
    getCompoundValue,
    setCompoundValue,
    removeCompoundValue,
    refreshCompoundValue
} from './localStorage';
import { ID_LENGTH } from '../constans';

export function randomId() {
    let id = String(Math.floor(Math.random() * Math.pow(10, ID_LENGTH)));
    while (id.length < ID_LENGTH) id = '0' + id;
    return id;
}

export function getSessionData(param) {
    try {
        const cookieName = getCookieName(param);
        const compoundCookie = getCompoundCookie(cookieName);
        const compoundLSValue = getCompoundValue(cookieName);

        // is cookie exists and no value in localStorage, move cookie to localStorage
        if (compoundCookie) {
            deleteCookie(cookieName);
            if (!compoundLSValue)
                setCompoundValue(
                    cookieName,
                    compoundCookie.value,
                    compoundCookie.date && compoundCookie.date.getTime()
                );
        }

        const compoundValue = getCompoundValue(cookieName);
        if (!compoundValue) return null;
        if (
            compoundValue.accessed &&
            compoundValue.accessed.getTime() + getCookieDuration(param) * 1000 < Date.now()
        )
            return null;
        return compoundValue;
    } catch (e) {
        return null;
    }
}

export function setSessionData(param, value) {
    try {
        const cookieName = getCookieName(param);
        if (!value) {
            deleteCookie(cookieName);
            removeCompoundValue(cookieName);
            return;
        }

        setCompoundValue(cookieName, value);
    } catch (e) {}
}

export function refreshSessionData(param) {
    try {
        const cookieName = getCookieName(param);
        refreshCompoundValue(cookieName);
    } catch (e) {}
}
